<template>
    <div class="grid gap-2">
        <div class="flex items-center justify-between w-full">
            <div class="flex items-center justify-start gap-2">
                <v-btn-toggle
                    v-model="currentTab"
                    @change="getList()"
                >
                    <template v-for="item in menu">
                        <v-btn
                            :key="item.text"
                            :value="item.value"
                        >
                            {{ item.text }}
                        </v-btn>
                    </template>
                </v-btn-toggle>
                <div class="flex items-center gap-1">
                    <v-text-field
                        v-model="searchText"
                        label="搜尋"
                        outlined
                        hide-details
                        dense
                        class="flex-initial"
                    />
                    <v-btn @click="getList()">
                        搜尋
                    </v-btn>
                </div>
            </div>
            <div class="grid grid-cols-3 gap-2">
                <!-- <v-btn
                    :to="`/competition/${activityId}/apply/create`"
                    color="primary"
                    class="col-span-1"
                >
                    新增項目
                    <v-icon>mdi-plus</v-icon>
                </v-btn> -->
                <v-file-input
                    v-model="excelFile"
                    label="匯入"
                    outlined
                    dense
                    hide-details
                    append-icon="mdi-upload"
                    prepend-icon=""
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    class="col-span-1"
                    @change="uploadApply"
                >
                    <template v-slot:selection="{ text }">
                        <v-chip
                            small
                            label
                            color="primary"
                        >
                            {{ text }}
                        </v-chip>
                    </template>
                </v-file-input>
                <v-btn
                    color="primary"
                    class="col-span-1"
                    @click="downloadApply()"
                >
                    匯出所有資料
                    <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-btn
                    color="primary"
                    class="col-span-1"
                    @click="downloadAllCertifications()"
                >
                    匯出本頁證書
                    <v-icon>mdi-download</v-icon>
                </v-btn>
            </div>
        </div>

        <div class="w-full overflow-scroll bg-white  rounded-lg">
            <!-- 頂部分頁控制 -->
            <v-data-footer
                :pagination="{
                    page: paginationOptions.page,
                    itemsPerPage: paginationOptions.itemsPerPage,
                    pageStart: (paginationOptions.page - 1) * paginationOptions.itemsPerPage,
                    pageStop: Math.min(
                        paginationOptions.page * paginationOptions.itemsPerPage,
                        total
                    ),
                    itemsLength: total,
                }"
                :options="paginationOptions"
                :items-per-page-options="[5, 10, 50]"
                items-per-page-text="每頁顯示："
                page-text=" {2} 條中的 {0}~{1} 條"
                @update:options="
                    (val) => {
                        paginationOptions = val;
                        getList();
                    }
                "
            />
            <v-data-table
                class="rounded-0"
                :items="list"
                :sort-by="sortBy.key"
                :sort-desc="sortBy.sortDesc"
                :headers="[
                    { text: '姓名', value: 'name', sortable: false, width: '100px' },
                    { text: '身分證', value: 'identity', sortable: false, width: '150px' },
                    { text: '繳費狀態', value: 'paid', sortable: false, width: '100px' },
                    { text: '繳費序號', value: 'serial', sortable: false, width: '120px' },
                    { text: '報名日期', value: 'createTime', width: '120px' },
                    { text: '備註欄', value: 'remark', sortable: false },
                    { text: '', value: 'actions', sortable: false, width: '220px' },
                ]"
                :server-items-length="total"
                :options="paginationOptions"
                :footer-props="{
                    'items-per-page-options': [5, 10, 50],
                }"
                @pagination="
                    (val) => {
                        paginationOptions = val;
                        getList();
                    }
                "
                @update:sort-by="
                    (val) => {
                        sortBy.key = val;
                        getList();
                    }
                "
                @update:sort-desc="
                    (val) => {
                        sortBy.sortDesc = val;
                        getList();
                    }
                "
            >
                <template v-slot:item.createTime="{ item }">
                    {{ item.createTime | formatDate }}
                </template>
                <template v-slot:item.identity="{ item }">
                    {{ item.identity.split("-")[0] }}
                </template>
                <template v-slot:item.paid="{ item }">
                    <template v-if="item.paid">
                        已繳費
                    </template>
                    <template v-else>
                        <strong>未繳費</strong>
                    </template>
                </template>
                <template v-slot:item.remark="{ item }">
                    <div
                        ref="remarkText"
                        class="remark-text"
                        :style="{ maxWidth: remarkMaxWidth ? `${remarkMaxWidth}px` : '500px' }"
                    >
                        {{ item.remark }}
                    </div>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn
                        v-if="currentTab === 'deleted'"
                        :to="`/competition/${activityId}/apply/view/${item.id}`"
                        small
                        class="mr-2"
                    >
                        檢視
                    </v-btn>
                    <v-btn
                        v-else
                        :to="`/competition/${activityId}/apply/${item.id}`"
                        small
                        class="mr-2"
                    >
                        編輯
                    </v-btn>
                    <!-- <v-btn
                    color="error"
                    small
                    class="mr-2"
                    @click="deleteItem(item)"
                >
                    刪除
                </v-btn> -->
                    <DialogUI
                        v-if="currentTab !== 'deleted'"
                        :id="item.id"
                        :name="item.name"
                        :identity="item.identity"
                        @record="record"
                    />
                    <!-- <v-icon
                    small
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon> -->
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { MessageBox } from 'element-ui';
import { downloadFile } from '@/utils/methods';
import DialogUI from '@/components/DialogUI.vue';

export default {
    components: {
        DialogUI,
    },
    props: {
        activityId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            sortBy: {
                key: 'createTime',
                sortDesc: true,
            },
            searchText: '',
            currentTab: '',
            menu: [
                { text: '全部', value: '' },
                { text: '個人', value: JSON.stringify({ $in: [null, ''] }) },
                { text: '團體', value: JSON.stringify({ $nin: [null, ''] }) },
                { text: '刪除', value: 'deleted' },
            ],
            paginationOptions: {
                page: 1,
                itemsPerPage: 10,
            },
            total: 0,
            list: [],
            excelFile: null,
            remarkMaxWidth: null,
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.total / this.paginationOptions.itemsPerPage);
        },
    },
    created() {
        this.getList();
    },
    mounted() {
        this.calculateRemarkWidth();
    },
    methods: {
        ...mapActions('mApply', [
            'List',
            'Create',
            'Delete',
            'Update',
            'Download',
            'DownloadCertificationsByAdmin',
            'Upload',
        ]),
        buildQuery() {
            const { page, itemsPerPage } = this.paginationOptions;
            const sort = JSON.stringify({ [this.sortBy.key]: this.sortBy.sortDesc ? -1 : 1 });
            return {
                offset: (page - 1) * itemsPerPage,
                limit: itemsPerPage,
                filter: `activity:${this.activityId}${
                    this.currentTab && this.currentTab !== 'deleted'
                        ? `;groupCellphone:json:${this.currentTab}`
                        : ''
                }`,
                sort,
                search: this.searchText ? this.searchText : undefined,
                stage: this.currentTab === 'deleted' ? 'deleted' : '',
            };
        },
        getList() {
            this.List(this.buildQuery()).then((res) => {
                this.list = res.data.raw;
                this.total = res.data.total;
                this.calculateRemarkWidth();
            });
        },
        deleteItem(item) {
            MessageBox.confirm(`「${item.name}」的報名資料`, {
                type: 'warning',
                title: '確認刪除？',
                confirmButtonText: '刪除',
                cancelButtonText: '取消',
            })
                .then(() => {
                    this.Delete(item.id).then(this.getList);
                })
                .catch(() => {});
        },
        downloadAllCertifications() {
            const currentPageCount = Math.min(
                this.paginationOptions.page * this.paginationOptions.itemsPerPage,
                this.total,
            ) - (this.paginationOptions.page - 1) * this.paginationOptions.itemsPerPage;

            downloadFile(`匯出證書_共${currentPageCount}份.zip`, () => this.DownloadCertificationsByAdmin({
                activityId: this.activityId,
                query: this.buildQuery(),
            }));
        },
        downloadApply() {
            downloadFile('apply.xlsx', () => this.Download(this.activityId));
        },
        uploadApply(file) {
            if (file) {
                const blobUrl = URL.createObjectURL(file);
                this.Upload({
                    activityId: this.activityId,
                    file: blobUrl,
                }).then(() => {
                    this.excelFile = null;
                    this.getList();
                });
            }
        },
        record() {
            this.getList();
        },
        calculateRemarkWidth() {
            this.$nextTick(() => {
                // 計算其他欄位的總寬度
                const fixedWidths = 100 + 150 + 100 + 120 + 120 + 220; // 其他欄位寬度總和
                const tableElement = this.$el.querySelector('.v-data-table');
                if (tableElement) {
                    const tableWidth = tableElement.getBoundingClientRect().width;
                    const availableWidth = tableWidth - fixedWidths - 40; // 減去 padding/margin
                    this.remarkMaxWidth = Math.max(availableWidth, 200); // 設定最小寬度

                    console.log('Table Width:', tableWidth);
                    console.log('Fixed Widths:', fixedWidths);
                    console.log('Available Width:', availableWidth);
                    console.log('Final Max Width:', this.remarkMaxWidth);
                }
            });
        },
    },
};
</script>
<style>
.remark-text {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: block !important;
}
</style>
